<template>
  <el-dialog
    class="member-history-dialog"
    :visible="visible"
    :before-close="handleClose"
    append-to-body
  >
    <div slot="title" class="history-title">
      <img :src="headerIcon" alt="" />
      <strong>订单记录</strong>
    </div>
    <div class="history-content" v-loading="loading">
      <el-table
        :data="paidRecords"
        height="388"
        class="history-table"
        empty-text="暂无订单记录"
        :header-cell-style="{
          backgroundColor: '#F5F7FA',
          color: '#333333',
          borderBottom: 'none'
        }"
      >
        <el-table-column
          prop="orderId"
          label="订单号"
          min-width="158"
          show-overflow-tooltip
        />
        <el-table-column label="类型" width="120"  >
          <template slot-scope="scope">{{ planType(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="金额" width="90">
          <template slot-scope="scope">{{ formatAmount(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="支付方式" width="110">
          <template slot-scope="scope">{{ paymentMethod(scope.row.source) }}</template>
        </el-table-column>
        <el-table-column label="支付时间" min-width="150">
          <template slot-scope="scope">{{
            formatTime(scope.row.paidAt || scope.row.createdAt)
          }}</template>
        </el-table-column>
        <el-table-column label="会员有效期" prop="validityPeriod" min-width="200"/>
        <el-table-column label="交易状态" width="100">
          <template slot-scope="scope"
            ><span :class="['history-status', statusClass(scope.row.status)]">{{
              statusText(scope.row.status)
            }}</span></template
          >
        </el-table-column>
      </el-table>
      <button type="button" class="history-contact" @click="$emit('contact')">
        <img :src="contactIcon" alt="" />
        联系客服
      </button>
    </div>
  </el-dialog>
</template>

<script>
import { queryMemberOrders } from "@/services/member";

export default {
  name: "MemberPurchaseHistoryDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      records: [],
      headerIcon: require("@/assets/imgs/payment/history-header-icon.png"),
      contactIcon: require("@/assets/imgs/payment/connect-button-icon.png"),
    };
  },
  computed: {
    paidRecords() {
      return this.records.filter((record) => record.status === "PAID");
    },
  },
  watch: {
    visible(value) {
      if (value) this.loadRecords();
    },
  },
  methods: {
    getCurrentUserId() {
      const storeUser = this.$store.getters["layout/getUserInfo"] || {};
      if (storeUser.id) return storeUser.id;
      try {
        const user = JSON.parse(
          localStorage.getItem("userInfo") ||
            localStorage.getItem("myUser") ||
            "{}"
        );
        return user.id || "";
      } catch (e) {
        return "";
      }
    },
    async loadRecords() {
      const userId = this.getCurrentUserId();
      if (!userId) return;
      this.loading = true;
      try {
        const response = await queryMemberOrders(String(userId), {
          page: 1,
          size: 100,
        });
        const payload =
          response && response.result ? response.result : response;
        this.records = Array.isArray(payload)
          ? payload
          : (payload &&
              (payload.records ||
                payload.list ||
                payload.content ||
                payload.data)) ||
            [];
      } catch (e) {
        this.records = [];
      } finally {
        this.loading = false;
      }
    },
    planType(row) {
      return row.planName || row.productName || row.planType || "--";
    },
    formatAmount(row) {
      const amountFen =
        row.amountFen != null ? row.amountFen : row.payAmountFen;
      if (amountFen != null) return ((Number(amountFen) || 0) / 100).toFixed(2);
      return Number(row.amount || row.payAmount || 0).toFixed(2);
    },
    paymentMethod(source) {
      return (
        {
          WECHAT_PAY: "微信支付",
          CARD_REDEEM: "兑换码核销",
        }[source] || "--"
      );
    },
    formatTime(value) {
      if (!value) return "--";
      const date = new Date(String(value).replace(/-/g, "/").replace("T", " "));
      if (!Number.isFinite(date.getTime())) return value;
      const pad = (number) => String(number).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`;
    },
    membershipPeriod(row) {
      const start = row.memberStartAt || row.validFrom || row.paidAt;
      const end = row.memberEndAt || row.validUntil;
      if (!start && !end) return "--";
      return `${this.formatTime(start).slice(0, 10)} 至${this.formatTime(
        end
      ).slice(0, 10)}`;
    },
    statusText(status) {
      return (
        {
          PAID: "已支付",
          PAYING: "支付中",
          CREATED: "待支付",
          CLOSED: "已关闭",
          FAILED: "失败",
        }[status] ||
        status ||
        "--"
      );
    },
    statusClass(status) {
      return status === "PAID"
        ? "success"
        : ["CLOSED", "FAILED"].includes(status)
        ? "failed"
        : "pending";
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.member-history-dialog {
  /deep/ .el-dialog {
    width: 1000px;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 12px;
    overflow: hidden;
    transform: translate(-50%, -50%);
    box-shadow: 0 18px 52px rgba(22, 41, 78, 0.2);
  }
  /deep/ .el-dialog__header {
    height: 60px;
    padding: 0 28px;
    border-bottom: 1px solid #edf0f5;
    box-sizing: border-box;
  }
  /deep/ .el-dialog__headerbtn {
    top: 25px;
    right: 28px;
    .el-dialog__close {
      color: #9399a7;
      font-size: 18px;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
.history-title {
  height: 60px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #202938;
  img {
    width: 24px;
    height: 24px;
  }
  strong {
    font-size: 16px;
  }
}
.history-content {
  height: 470px;
  padding: 0 28px 16px;
  box-sizing: border-box;
}
.history-table {
  margin-top: 10px;
  width: 100%;
}
.history-status.success {
  color: #29b96f;
}
.history-status.pending {
  color: #e8a12f;
}
.history-status.failed {
  color: #a5aab4;
}
.history-contact {
  height: 38px;
  margin-top: 8px;
  padding: 0 14px;
  border: 1px solid #dfe4eb;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #566074;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>


